import type { DMConversationMessage } from '@/components/pages/conversations/SocialInbox/types';

import { BaseMedia } from './BaseMedia';

type VideoFileInfo = {
    width: number;
    height: number;
    size: number;
    mime_type: string;
    aspect_ratio: number;
    audio_bitrate: number;
    video_bitrate: number;
    duration: number;
    framerate: number;
    pixel_size: number;
};

export class VideoMedia extends BaseMedia {
    type: 'video';
    video: string;
    thumbnail: string;
    file_info: VideoFileInfo;

    constructor(attachment: DMConversationMessage['attachments'][0]) {
        super(attachment);
        this.type = 'video';
        this.video = attachment.url;
        this.thumbnail = attachment.preview_url;
        this.file_info = {
            width: parseInt(attachment.width),
            height: parseInt(attachment.height),
            size: 0,
            mime_type: attachment.type,
            aspect_ratio: 0,
            audio_bitrate: 0,
            video_bitrate: 0,
            duration: 0,
            framerate: 0,
            pixel_size: 0
        };
    }
}
